import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import type { UseQueryOptions } from "react-query";
import { useQuery } from "react-query";

interface EmailHubStatusCircuitBreakers {
  broadcasts: boolean;
}

export interface EmailHubStatusNonAdminData {
  circuit_breakers: EmailHubStatusCircuitBreakers;
  enabled: boolean;
}

export interface EmailHubStatusAdminData {
  circuit_breakers: EmailHubStatusCircuitBreakers;
  enabled: boolean;
  lapsed: boolean;
  limits: {
    marketing_email_limit_reached: boolean;
    marketing_email_limit: number;
    marketing_email_usage_in_period: number;
    marketing_email_limit_period_in_hours: number;
    allowance: number;
  };
  plan: {
    cancel_at_period_end: boolean;
    current_period_end: string;
    status: string;
  };
  sender_assessments: {
    state: "normal" | "warning" | "suspend" | "blocked" | "flagged";
    allow_sending: boolean;
  };
  show_limits_notice: boolean;
  trialing: boolean;
}

export const EMAIL_HUB_STATUS_QUERY_KEY = "email-hub-status";

export const isAdminData = (
  data: EmailHubStatusAdminData | EmailHubStatusNonAdminData | undefined,
): data is EmailHubStatusAdminData => !!data && "limits" in data;

export const useGetEmailHubStatus = (
  options?: Omit<
    UseQueryOptions<
      EmailHubStatusAdminData | EmailHubStatusNonAdminData,
      unknown
    >,
    "queryKey"
  >,
) =>
  useQuery<EmailHubStatusAdminData | EmailHubStatusNonAdminData, unknown>({
    ...options,
    queryKey: [EMAIL_HUB_STATUS_QUERY_KEY],
    queryFn: () => reactQueryGet(internalApi.emailHubStatus.show()),
    staleTime: 10 * 60 * 1000,
  });
